import { VMTitleAndSceneInfo } from '../types/vm-types';

function getAbsis2DefaultObject(): unknown {
  return {
    Metainformacion: {
      titulo_pestanya: '',
    },
    Escenario: {
      tipo_escenario: 'DES',
    },
    /*Favorito: {
      datosPagina: null,
      idAPL: 'CA.OFI.Home.VisualizarHome',
      tituloAPL: null,
      params: null,
      tipoAPL: 'tf7',
      datos: null,
    },*/
  };
}

export function changeMetaInfoData(data: VMTitleAndSceneInfo): unknown {
  const absis2Data: any = getAbsis2DefaultObject();

  absis2Data.Metainformacion.titulo_pestanya =
    data.tabTitle || absis2Data.Metainformacion.titulo_pestanya;

  absis2Data.Escenario.tipo_escenario =
    data.scene || absis2Data.Escenario.tipo_escenario;

  return absis2Data;
}
